__webpack_public_path__ = window.__baseHref + 'dist/';